import React from 'react';
import { i18n_meditations } from '@yi/i18n/phrases/i18n_meditations';
import { i18n_seo_meditations_learn_to_meditate } from '@yi/i18n/phrases/i18n_seo_meditations_learn_to_meditate';

import { MainLayout, useLocale, MeditationsPage as MeditationsPageBody } from '~/components';

const MeditationsPage: React.FC = () => {
  const { locale } = useLocale();
  const SEO = {
    description: i18n_seo_meditations_learn_to_meditate(locale),
  };

  return (
    <MainLayout seo={SEO} pageTitle={i18n_meditations(locale)}>
      <MeditationsPageBody />
    </MainLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default MeditationsPage;
